export default __webpack_public_path__ + "static/media/8.70872454.png";